import { Button, Text, TableContainer, Table, Thead, Tr, Tbody, Td, TableCaption, Flex, Spinner, useToast } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { api } from '../../../../services/api'
import { Th } from './Th'
import InputFloating from '../../../../components/InputFloating'
import { useForm } from 'react-hook-form'
import { NotasAntecipadas } from './NotasAntecipadas'
import { TrItem } from './TrItem'

const FiltroTabelas = ({ dados, resultado, view_loading_update }) => {
  const [loadingUpdate, setloadingUpdate] = useState(false)
  const [notasAntecipadas, setNotasAntecipadas] = useState([])
  const toast = useToast()
  const { register, handleSubmit } = useForm()

  function getNotasAntecipadas() {
    const notas = dados.filter((item) => item.nota_antecipada === 'S')
    setNotasAntecipadas(notas)
  }

  useEffect(() => {
    getNotasAntecipadas()
  }, [dados])

  async function updateNota(data) {
    try {
      setloadingUpdate(true)

      const response = await api.post(`/site/v2/pedido/atualiza-pendencia-nota`, {
        numero_unico: data.numero_pedido,
        numero_pedido: data.numero_nota,
      })

      toast({
        title: 'Sucesso!',
        description: 'Atualizado com sucesso!',
        status: 'success',
        duration: 9000,
        isClosable: true,
      })

      resultado({
        codParc: '',
        pedido: '',
        dataDe: '',
        dataAte: '',
        pendente: '',
        nfe: '',
      })
    } catch (error) {
      toast({
        title: 'Erro!',
        description: 'Erro ao atualizar!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
      setloadingUpdate(false)
    }

    setloadingUpdate(false)
  }

  return (
    <>
      <Flex w={'full'} justifyContent={'space-between'} alignItems={'flex-end'} mb={'1rem'} paddingInline={5}>
        <Flex maxW={'600px'} w={'full'} gap={6} as="form" onSubmit={handleSubmit(updateNota)} flexDir="column">
          <Text as="h2" fontSize="1.2rem" fontWeight="bold" color="gray.600">
            Envio de nota por E-mail.
          </Text>
          <Flex gap={'2'}>
            <InputFloating label={'Numero Único'} {...register('numero_pedido', { required: true })} />
            <InputFloating label={'Numero Pedido'} {...register('numero_nota', { required: true })} />
            <Button type="submit" colorScheme="blue" size="md" loadingText="Enviando" isLoading={loadingUpdate}>
              Enviar
            </Button>
          </Flex>
        </Flex>

        <Flex gap={'2rem'}>
          <NotasAntecipadas dados={notasAntecipadas} resultado={resultado} />
          <Text as="h2" fontSize="1.2rem" fontWeight="bold" color="gray.600">
            {dados.length} pedidos
          </Text>
        </Flex>
      </Flex>

      <TableContainer>
        <Table fontSize="12px">
          <TableCaption>Tabela de informações de notas fiscais pendentes de emissão</TableCaption>
          <Thead>
            <Tr>
              <Th label="Nº Ped" />
              <Th label="Nº Único" />
              <Th label="Pré Danfe" />

              <Th label="Limite Produção" />
              <Th label="Solicitação Nota" />
              <Th label="Nome do cliente" />
              <Th label="Nome parc" />
              {/* <Th label="Peso total" /> */}
              <Th label="Peso real" />
              <Th label="Qtd de Caixas" />
              <Th label="Transp" />
              <Th label="Remessa" />
              <Th label="Tem ST" />
              <Th label="Validação de NF" />
              <Th label="NF Validada" />
              <Th label="Valor nota" />
              <Th label="Nota Finalização" />
              <Th label="Nota antecipada" />
              <Th />
            </Tr>
          </Thead>
          <Tbody>
            {view_loading_update && (
              <Tr>
                <Td colSpan="15" padding=".3rem" textAlign="center">
                  <Spinner size="md" color="green.500" />
                </Td>
              </Tr>
            )}
            {!view_loading_update &&
              dados.map((data, idx) => {
                return <TrItem data={data} key={idx} idx={idx} resultado={resultado} getNotasAntecipadas={getNotasAntecipadas} />
              })}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  )
}

export default FiltroTabelas
